var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12c0 .5-.5 1-1 1H6.4l2.3 2.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-4-4c-.4-.4-.4-1 0-1.4l4-4c.2-.2.4-.3.7-.3s.5.1.7.3c.4.4.4 1 0 1.4L6.4 11H20c.5 0 1 .5 1 1zM20 7h-8.4c-.6 0-1-.4-1-1s.4-1 1-1H20c.6 0 1 .4 1 1s-.4 1-1 1zM20 19h-8.4c-.6 0-1-.4-1-1s.4-1 1-1H20c.6 0 1 .4 1 1s-.4 1-1 1z"
  })));
}

export default SvgIconMenuCollapse;